import About from "@/components/About";
import Stats from "@/components/Stats";
import useDocumentMeta from "@/lib/useDocumentMeta";

export default function AboutPage() {
    useDocumentMeta({
        title: "За нас · Konstantin Mobile — Премиум автокъща в Петрич",
        description:
            "Konstantin Mobile е премиум автокъща в Петрич с над 15 години опит. Над 700 продадени автомобила, проверена история, прозрачна сервизна документация.",
        path: "/about",
    });
    return (
        <main data-testid="about-page" className="pt-24">
            <About />
            <Stats />
        </main>
    );
}
